/**
* this is the my fund page which show the fund information
*
* Created by Min on 17/08/18
*/

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import cx from 'classnames'
import { connect } from 'react-redux'
import moment from 'moment'

// action import
import { ActionCreator } from '../../actions/'

// component import
import EmptyData from '../../components/EmptyData/'
import SimpleLoader from '../../components/SimpleLoader/'
import PrintIcon from '../../assets/svg/print.svg'

// style import
import './style.scss'
import './print-style.scss'


class Fund extends Component {

    componentDidMount() {
        const { getFundData } = this.props
        getFundData()
    }

    // render a single item of fund information
    renderItem (label, value) {
        return (
                <div className="info-block__item">
                    <div className="item-label">{label}:</div>
                    <div className="item-value">{value ? value : "Not supplied"}</div>
                </div>
        )
    }

    // render fund information
    renderFundInfo (data) {
        return (
            <div className="info-block info-block--fund">
                <div className="info-block__heading">Fund Information</div>
                {this.renderItem("Fund name", data['fund_name'])}
                {this.renderItem("Fund type",  data['fund_type'])}
                {this.renderItem("Jurisdiction", data['jurisdiction'])}
            </div>
        )
    }

    // render members/trustees information
    renderMemberTrusteeInfo (heading, data, index) {
        return (
            <div key={index} className="info-block info-block--member-trustee">
                <div className="info-block__heading">
                    {heading}
                    <div className="info-block__sub-heading">
                        {index===0 && <span>(Selfmade account holder)</span>}
                    </div>
                </div>

                {this.renderItem("Title", data['title'])}
                {this.renderItem("First name", data['first_name'])}
                {this.renderItem("Middle name", data['middle_name'])}
                {this.renderItem("Last name", data['last_name'])}
                {this.renderItem("Email", data['email'])}
                {index===0 && this.renderItem("Phone", data['phone'])}
                {this.renderItem("Date of birth", moment(data['date_of_birth']).format('DD/MM/YYYY'))}
                {this.renderItem("TFN", data['tfn'])}
                {this.renderItem("Occupation type", data['occupation_type'])}
                {this.renderItem("Occupation sub-type", data['occupation_category'])}
                {this.renderItem("Residential address", data['residential_address'])}
                {this.renderItem("Residential unit#", data['residential_unit'])}
                {this.renderItem("Residential suburb", data['residential_suburb'])}
                {this.renderItem("Residential state", data['residential_state'])}
                {this.renderItem("Residential postcode", data['residential_postcode'])}
                {/* Only the first truess has postal info */}
                {index===0 && this.renderItem("Postal address", data['postal_address'])}
                {index===0 && this.renderItem("Postal unit#", data['postal_unit'])}
                {index===0 && this.renderItem("Postal suburb", data['postal_suburb'])}
                {index===0 && this.renderItem("Postal state", data['postal_state'])}
                {index===0 && this.renderItem("Postal postcode", data['postal_postcode'])}
            </div>
        )
    }

    // render print button
    renderPrintButton () {
        return (
            <div className="print-btn no-print">
                <a href="#"  onClick={() => window.print()}>
                    <img
                        src={PrintIcon}
                        className="print-icon"
                        alt="Left menu close icon"/>
                    <span>Print this page</span>
                </a>
            </div>
        )
    }

    render() {
        const { fundInfoData, membersTrusteesInfoData, isLoading } = this.props

        // show/hide empty image based on whether there is 'data' to be displayed
        const dynClassEmpty = cx('fund__empty', {
            'fund__empty--show': (!fundInfoData || membersTrusteesInfoData.length===0 ) && !isLoading
        })

        // show/hide the fund based on whether there is 'data' to be displayed
        const dynClassContent = cx('fund__content', {
            'fund__content--show': membersTrusteesInfoData.length!==0 && fundInfoData && !isLoading
        })

        return (
            <div className="fund main-wrapper" ref={el => (this.componentRef = el)}>
                <div className="main-container">

                    <div className="title-section">
                        <div className="page-title">MY FUND</div>
                        {/* print btn */}
                        {this.renderPrintButton()}
                    </div>

                    {/* loader */}
                    <SimpleLoader
                        num={3}
                        show={isLoading}
                        title="Please wait while we fetch your fund information."
                    />

                    {/* content */}
                    <div className={dynClassContent}>
                        {this.renderFundInfo(fundInfoData)}
                        <div className="member-trustee-info">
                            {membersTrusteesInfoData.map(
                                (item,index)=>{return this.renderMemberTrusteeInfo(item['heading'],item['data'], index)}
                            )}
                        </div>
                    </div>

                    {/* empty component */}
                    <div className={dynClassEmpty}>
                        <EmptyData
                            headerText="Fund information"
                            notificationText="Sorry, we were not able to fetch your fund information at this time. Please try again later."
                        />
                    </div>
                </div>
            </div>
        )
    }
}

// define the prop types
Fund.propTypes = {
    fundInfoData: PropTypes.object,
    membersTrusteesInfoData: PropTypes.array,
    isLoading: PropTypes.bool,
}

const mapStateToPros = (state) => {
    return {
        fundInfoData: state.fundState.fundInfoData,
        membersTrusteesInfoData: state.fundState.membersTrusteesInfoData,
        isLoading: state.fundState.isLoading,
    }
}

const mapDispatchToProps = (dispatch) => {
    const action = bindActionCreators(ActionCreator, dispatch)
    return {
        getFundData: action.getFundData
    }
}


export default connect(mapStateToPros,mapDispatchToProps)(Fund)



// WEBPACK FOOTER //
// ./src/pages/Fund/index.js